import moment from 'moment';
import PropTypes from 'prop-types';
import CommentThreadShape from './CommentThreadShape';
import ExternalPostShape from './ExternalPostShape';
import SeriesShape from './SeriesShape';
import TopicShape from './TopicShape';
import UserShape from './UserShape';
import VerificationEntryShape from './VerificationEntryShape';
import VerificationShape from './VerificationShape';

const PostShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  title: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types -- Fix next time editing the file
  content: PropTypes.arrayOf(PropTypes.object),
  publicUrl: PropTypes.string,
  contributors: PropTypes.arrayOf(UserShape),
  topics: PropTypes.arrayOf(TopicShape),
  threads: PropTypes.arrayOf(CommentThreadShape),
  archiver: UserShape,
  owner: UserShape,
  archivedAt: PropTypes.string,
  insertedAt: PropTypes.string,
  updatedAt: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(moment),
  ]),
  publishedAt: PropTypes.string,
  reads: PropTypes.number,
  views: PropTypes.number,
  version: PropTypes.number,
  score: PropTypes.number,
  viewers: PropTypes.arrayOf(UserShape),
  externalPost: ExternalPostShape,
  series: SeriesShape,
  verification: VerificationShape,
  verificationEntries: PropTypes.arrayOf(VerificationEntryShape),
});

export default PostShape;
